module.exports = __webpack_public_path__ + "static/media/venue-3.24c5ed76.jpg";